import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SupportModule } from '../support/support.module';

import { ImageHintDirective } from './image-hint/image-hint.directive';

import { TextComponent } from './text/text.component';
import { TextsComponent } from './texts/texts.component';
import { NumberComponent } from './number/number.component';
import { DateComponent } from './date/date.component';
import { DatetimeComponent } from './datetime/datetime.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { AutogroupComponent } from './autogroup/autogroup.component';
import { InputComponent } from './input/input.component';
import { TextareaComponent } from './textarea/textarea.component';
import { EmailComponent } from './email/email.component';
import { ColorComponent } from './color/color.component';
import { SliderComponent } from './slider/slider.component';
import { ToggleComponent } from './toggle/toggle.component';
import { SelectComponent } from './select/select.component';
import { TypeComponent } from './type/type.component';
import { ContentPickerComponent } from './content-picker/content-picker.component';
import { AspectPickerComponent } from './aspect-picker/aspect-picker.component';
import { PrototypePickerComponent } from './prototype-picker/prototype-picker.component';
import { SearchComponent } from './search/search.component';
import { AssentComponent } from './assent/assent.component';
import { OptionComponent } from './option/option.component';
import { DividerComponent } from './divider/divider.component';
import { RolePickerComponent } from './role-picker/role-picker.component';
import { ClientPickerComponent } from './client-picker/client-picker.component';
import { ErrorComponent } from './error/error.component';
import { PasswordComponent } from './password/password.component';
import { IndexerComponent } from './indexer/indexer.component';
import { LabelComponent } from './label/label.component';
import { ImageComponent } from './image/image.component';
import { ImageHintComponent } from './image-hint/image-hint.component';
import { ImagesComponent } from './images/images.component';
import { JavaScriptComponent } from './java-script/java-script.component';
import { JsonComponent } from './json/json.component';
import { KeyComponent } from './key/key.component';
import { GraphQLCheckerComponent } from './graphql-checker/graphql-checker.component';
import { DictionaryComponent } from './dictionary/dictionary.component';
import { FormulaComponent } from './formula/formula.component';

import { MaterialModule } from './material.module';

@NgModule({
  declarations: [
    ImageHintDirective,

    TextComponent,
    TextsComponent,
    NumberComponent,
    AutogroupComponent,
    DateComponent,
    DatetimeComponent,
    CheckboxComponent,
    AutocompleteComponent,
    InputComponent,
    TextareaComponent,
    EmailComponent,
    ColorComponent,
    SliderComponent,
    ToggleComponent,
    SelectComponent,
    TypeComponent,
    ContentPickerComponent,
    AspectPickerComponent,
    PrototypePickerComponent,
    SearchComponent,
    AssentComponent,
    OptionComponent,
    DividerComponent,
    RolePickerComponent,
    ClientPickerComponent,
    ErrorComponent,
    PasswordComponent,
    LabelComponent,
    IndexerComponent,
    ImageComponent,
    ImageHintComponent,
    ImagesComponent,
    JavaScriptComponent,
    JsonComponent,
    KeyComponent,
    GraphQLCheckerComponent,
    DictionaryComponent,
    FormulaComponent
  ],
  imports: [
    CommonModule,
    SupportModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [
    CommonModule,
    SupportModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,

    CheckboxComponent,
    AutocompleteComponent,
    AutogroupComponent,
    TextComponent,
    TextsComponent,
    NumberComponent,
    DateComponent,
    DatetimeComponent,
    TextareaComponent,
    EmailComponent,
    ColorComponent,
    SliderComponent,
    ToggleComponent,
    SelectComponent,
    TypeComponent,
    ContentPickerComponent,
    AspectPickerComponent,
    PrototypePickerComponent,
    AssentComponent,
    OptionComponent,
    DividerComponent,
    RolePickerComponent,
    ClientPickerComponent,
    ErrorComponent,
    PasswordComponent,
    LabelComponent,
    IndexerComponent,
    JavaScriptComponent,
    JsonComponent,
    KeyComponent,
    GraphQLCheckerComponent,
    DictionaryComponent,
    FormulaComponent,
    ImageHintDirective,
    ImageComponent,
    ImageHintComponent,
    ImagesComponent
  ]
})
export class InputModule { }
export * from './input.constant';
export * from './text/text.component';
export * from './texts/texts.component';
export * from './number/number.component';
export * from './date/date.component';
export * from './datetime/datetime.component';
export * from './checkbox/checkbox.component';
export * from './autocomplete/autocomplete.component';
export * from './autogroup/autogroup.component';
export * from './input/input.component';
export * from './textarea/textarea.component';
export * from './email/email.component';
export * from './color/color.component';
export * from './slider/slider.component';
export * from './toggle/toggle.component';
export * from './select/select.component';
export * from './type/type.component';
export * from './content-picker/content-picker.component';
export * from './aspect-picker/aspect-picker.component';
export * from './prototype-picker/prototype-picker.component';
export * from './search/search.component';
export * from './assent/assent.component';
export * from './option/option.component';
export * from './divider/divider.component';
export * from './role-picker/role-picker.component';
export * from './client-picker/client-picker.component';
export * from './error/error.component';
export * from './password/password.component';
export * from './label/label.component';
export * from './indexer/indexer.component';
export * from './java-script/java-script.component';
export * from './json/json.component';
export * from './key/key.component';
export * from './graphql-checker/graphql-checker.component';
export * from './dictionary/dictionary.component';
export * from './formula/formula.component';
export * from './image-hint/image-hint.directive';
export * from './image/image.component';
export * from './image-hint/image-hint.component';
export * from './images/images.component';
